<template>
<CRow>
    <!-- <CCol col="12" class="mb-4">
        <CListGroup dir="ltr" class="p-0">
            <CListGroupItem class="text-left horizental-scroll">
                <CButton :color="btnColor" class="mr-2" v-clipboard:copy="store.account_id" v-clipboard:success="accountIdCopied">
                    <FaIcon icon="copy" />
                </CButton>
                <span class="font-weight-bold">ACCOUNT ID:</span> {{ store.account_id }}
                <span v-if="accountIdCopyStatus" class="text-success font-weight-bold mt-2 mx-3">{{ $t('developer.copied') }}</span>
            </CListGroupItem>
        </CListGroup>
    </CCol> -->

    <CCol col="12">
        <CCard>
            <CCardHeader class="cursor-pointer" :class="{active: collapse === 'plugin'}" @click="collapse = 'plugin'">سیستم‌های مدیریت محتوا</CCardHeader>
            <CCollapse :show="collapse == 'plugin'">
                <CCardBody>
                    <!-- <p>
                        بعد از نصب کافی است اکانت آیدی <span class="font-weight-bold">(ACCOUNT ID)</span> را از بالا کپی کرده و در تنظیمات افزونه جایگذاری نمایید.
                    </p> -->
                    <p>
                        کافی است افزونه را نصب کرده و فعال کنید.
                    </p>
                    <a href="https://github.com/affili-ir/affili-wc-tracker/archive/refs/tags/6.0.0.zip" class="text-affili-indigo font-2x" target="_blank" download>
                        <span class="d-block mb-3">
                            <img style="width:50px;" class="mfe-2" src="//statics.affili.ir/storage/assets/cms/wordpress.svg" />
                            <span class="font-lg" style="vertical-align: middle;">افزونه وردپرس</span>
                        </span>
                    </a>
                    <a href="https://github.com/affili-ir/affili-presta-tracker/archive/refs/tags/1.0.0.zip" class="text-affili-indigo font-2x" target="_blank" download>
                        <span class="d-block mb-3">
                            <img style="width:50px;" class="mfe-2" src="//statics.affili.ir/storage/assets/cms/prestashop.svg" />
                            <span class="font-lg" style="vertical-align: middle;">افزونه پرستاشاپ</span>
                        </span>
                    </a>
                </CCardBody>
            </CCollapse>
        </CCard>
    </CCol>

    <CCol col="12">
        <CCard>
            <CCardHeader class="cursor-pointer" :class="{active: collapse === 'indivisual'}" @click="collapse = 'indivisual'">مستندات پیاده سازی</CCardHeader>
            <CCollapse :show="collapse == 'indivisual'">
                <CCardBody>
                    <p>در صورتی که سایت شما به صورت اختصاصی کد نویسی شده و از سیستم‌های مدیریت محتوا استفاده نمی‌کنید. توسط مستند فنی زیر می‌توانید اسکریپت افیلی را پیاده‌سازی کنید.</p>

                    <a href="https://statics.affili.ir/docs/script.pdf" class="text-affili-indigo font-2x" target="_blank" download>
                        <FaIcon icon="file-pdf" class="mfe-2 font-lg" />
                        <span class="font-lg">دانلود مستند فنی</span>
                    </a>
                </CCardBody>
            </CCollapse>
        </CCard>
    </CCol>

    <CCol col="12">
        <CCard>
            <CCardHeader class="cursor-pointer" :class="{active: collapse === 'affili'}" @click="collapse = 'affili'">پیاده‌سازی توسط افیلی</CCardHeader>
            <CCollapse :show="collapse == 'affili'">
                <CCardBody>
                    <p>اگر به هر دلیلی قادر به پیاده‌سازی اسکریپت نیستید. تیم پشتیبانی فنی افیلی می‌تواند برای شما پیاده‌سازی اسکریپت را انجام دهد.</p>

                    <p class="font-lg text-danger font-weight-bold">
                        هزینه پیاده‌سازی: 10,0000,000 ریال
                    </p>

                    <CButton type="button" color="outline-affili-cerise" @click="nxt">پیاده‌سازی توسط تیم افیلی</CButton>
                </CCardBody>
            </CCollapse>
        </CCard>
    </CCol>
</CRow>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { MarkdownDisplay } from '@/components'
import markdown from './markdown-single.js'
import { UserSetupStatus } from '@/constants'

export default {
    name: 'SetupAffiliScriptSingle',

    components: {
        MarkdownDisplay,
    },

    data() {
        return {
            accountIdCopyStatus: false,
            accesstIdCopyStatus: false,
            markdown,
            collapse: 'plugin',
            btnColor: 'primary'
        }
    },

    computed: {
        ...mapGetters({
            store: 'store/firstStore'
        }),
    },
    methods: {
        ...mapActions({
            changeCurrentUserSetupStatus: 'user/changeCurrentUserSetupStatus',
        }),
        accountIdCopied() {
            this.accountIdCopyStatus = true
            this.btnColor = 'success'
            setTimeout(() => {
                this.accountIdCopyStatus = false
                this.btnColor = 'primary'
            }, 1000)
        },
        nxt() {
            this.changeCurrentUserSetupStatus(UserSetupStatus.CHARGE_ACCOUNT)
        }
    }
}
</script>

<style lang="scss" scoped>
    ::v-deep .card-header.active {
        background-color: #ebedef !important;
        transition: all .2s;
    }
    ::v-deep .span-style > span{
        font-weight: 700 !important;
        background-color: #ebedef !important;
    }
</style>